<template>
  <Head title="Login" />
  <div class="min-h-screen grid grid-cols-1 md:grid-cols-2">
    <div class="flex items-center justify-center bg-white rounded-t-lg md:rounded-none md:rounded-l-lg min-h-full border-r-2">
      <form class="mt-1 w-full max-w-lg" @submit.prevent="login">
        <img src="/images/allumer_logo.png">
        <div class="py-12 px-10 md:px-0">
          <h1 class="text-left text-3xl font-bold text-purple-200 font-roboto uppercase">ALLUMER SOLUÇÕES</h1>
          <h1 class="text-left text-3xl text-black_light font-roboto-light uppercase pt-3">Painel do Administrador v1.2.355</h1>
          <div class="mt-6 mx-auto w-100 border-b-2" />
          <h1 class="text-left text-3xl font-bold text-black_light font-roboto-bold pt-5">Login</h1>
          <text-input v-model="form.user_name" :error="form.errors.user_name" class="mt-10" label="Login" type="text" autofocus autocapitalize="off" />
          <password-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Senha" />
          <div class="text-right mt-5 text-blue_link">
            <a href="forgot-password">Esqueceu a senha ?</a>
          </div>
          <div class="flex items-center justify-center">
            <loading-button :loading="form.processing" class="btn-purple w-80 mt-6 justify-center" type="submit">Login</loading-button>
          </div>
        </div>
      </form>
    </div>
    <div class="min-h-screen flex items-center justify-center
    bg-center bg-no-repeat login-background">
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import LoadingButton from '@/Shared/LoadingButton'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    PasswordInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        user_name: this.$user.username,
        password: this.$user.password,
        remember: false,
      }),
    }
  },

  mounted() {
    const { clearFilters } = useMemorizeFilters()
    clearFilters()
  },

  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
